// @ts-nocheck
import React, {
  FunctionComponent,
  ReactElement,
  useEffect,
  useState,
} from 'react'
import { useHistory } from 'react-router-dom'
import * as queryString from 'query-string'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import Skeleton from 'react-loading-skeleton'
import { campaignsList, scheduleCampaign } from 'Router/routes'
import { getCampaigns, getCampaignsLoader } from 'Redux/selectors/campaigns'
import { signInSpotify } from 'Redux/actions/auth'
import { getUser, getIsFirstCampaign } from 'Redux/selectors/auth'
import { WhiteGreenBtn } from 'Stories/Button/Button.stories'
import { locationEvent, pageInfo, pageViewEvent } from 'Helpers/tagManager'
import { IconPartyPopper } from 'Stories/Icon/Icon.stories'
import { getSpotifyToken } from 'Redux/selectors/spotifyToken'
import CampaignsList from './components/CampaignsList'
import CampaignEmptyPage from './components/CampaignEmptyPage'

import { User } from '../../Types'

import {
  CampaignsContainer,
  Card,
  CampaignsContainerPageSubHeader,
  SuccessBlock,
  SuccessButtonBlock,
  SuccessText,
  SuccessTitle,
  CustomModal,
} from './styles'

const Campaigns: FunctionComponent = (): ReactElement => {
  const { t } = useTranslation()

  const history = useHistory()
  const isFirstCampaign = useSelector(getIsFirstCampaign)
  const user: User = useSelector(getUser)
  const campaigns = useSelector(getCampaigns)
  const spotifyAccessToken = useSelector(getSpotifyToken)

  const loading: boolean = useSelector(getCampaignsLoader)

  useEffect(() => {
    if (user) {
      pageViewEvent(user, pageInfo.campaigns)
      locationEvent()
    }
  }, [user])

  const [isTrackSubmittedModal, setIsTrackSubmittedModal] = useState(
    localStorage.isTrackSubmittedModal || ''
  )

  const [campaignType, setCampaignType] = useState(
    localStorage.campaignType || ''
  )

  const handleCloseModal = () => {
    setIsTrackSubmittedModal('')
    localStorage.removeItem('isTrackSubmittedModal')
    setCampaignType('')
    localStorage.removeItem('campaignType')
  }

  useEffect(() => {
    if (history.location.search.indexOf('user') !== -1) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const userData: any = queryString.parse(location.search)
      let parsedUser = null
      let redirectUrl

      if (!isEmpty(userData)) {
        parsedUser = JSON.parse(userData.user)
        if (parsedUser.schedule) {
          const {
            utm_source,
            utm_campaign,
            utm_content,
            trigger_source,
            trigger_subject,
          } = userData

          if (trigger_source) {
            redirectUrl = `${campaignsList}${scheduleCampaign}/${parsedUser.campaign_id}/?trigger_source=${trigger_source}&trigger_subject=${trigger_subject}&userid=${parsedUser.user.id}`
          } else {
            redirectUrl = `${campaignsList}${scheduleCampaign}/${parsedUser.campaign_id}/?utm_source=${utm_source}&utm_content=${utm_content}&utm_campaign=${utm_campaign}`
          }
          history.push(redirectUrl)
        } else {
          signInSpotify(parsedUser)
          history.push('/')
        }
      }
    }
  }, [])

  if (isTrackSubmittedModal) {
    return (
      <CustomModal>
        <SuccessBlock>
          <SuccessTitle>
            {campaignType
              ? t('createCampaignPage.youCreatedYourCampaign!')
              : t('createCampaignPage.youCreatedYourFirstCampaign!')}

            {campaignType ? null : <IconPartyPopper />}
          </SuccessTitle>
          <SuccessText>
            {t('createCampaignPage.ourA&RTeamWillReviewYourCampaignStayTuned')}
          </SuccessText>
          <SuccessText>{t('createCampaignPage.weWillNotify')}</SuccessText>
          <SuccessButtonBlock>
            <WhiteGreenBtn color="whiteGreen" onClick={handleCloseModal}>
              {t('login.continue')}
            </WhiteGreenBtn>
          </SuccessButtonBlock>
        </SuccessBlock>
      </CustomModal>
    )
  }

  const checkEmptiness = campaigns => {
    if (loading) {
      return <Skeleton count={30} height={50} />
    }
    if (campaigns?.length !== 0) {
      return (
        <>
          <CampaignsList />
        </>
      )
    }
    return <CampaignEmptyPage spotifyAccessToken={spotifyAccessToken} />
  }

  return (
    <CampaignsContainer>
      <CampaignsContainerPageSubHeader>
        {t('campaignsPage.pageTitle')}
      </CampaignsContainerPageSubHeader>

      <Card>{checkEmptiness(campaigns)}</Card>
    </CampaignsContainer>
  )
}

export default Campaigns
